import bremen from "./images/2_.jpg";
import tekbond from "./images/Banner-Productos-Tekbond.jpg";
import einhell from "./images/einhell-logo.png";
import stanley from "./images/kanton-banner2.jpg";

const navList = [
	{ id: "1", name: "Bremen", value: "Bremen", image: `${bremen}` },
	{ id: "2", name: "Einhell", value: "Einhell", image: `${einhell}` },
	{ id: "3", name: "Tekbond", value: "Tekbond", image: `${tekbond}` },
	{ id: "4", name: "Stanley", value: "Stanley", image: `${stanley}` },
];

export { navList };
